import { TypedDocumentNode } from '@graphql-typed-document-node/core';
import { QueryClient } from '@tanstack/react-query';
import { GqlMutation } from './GqlMutation';
import { GqlOperationFactory } from './GqlOperationFactory';

export class GqlMutationFactory {
  private _gqlOperationFactory: GqlOperationFactory;
  private _queryClient: QueryClient;
  constructor(args: { gqlOperationFactory: GqlOperationFactory; queryClient: QueryClient }) {
    this._gqlOperationFactory = args.gqlOperationFactory;
    this._queryClient = args.queryClient;
  }

  createFromGql<V extends Record<string, unknown>, D extends Record<string, unknown>>(options: {
    canWorkWithShareLinks: boolean;
    document: TypedDocumentNode<D, V>;
    onSettled?: (args: { variables: V }) => void;
  }) {
    const operation = this._gqlOperationFactory.createFromGql(options);
    return new GqlMutation({
      onSettled: options.onSettled,
      operation,
      queryClient: this._queryClient,
    });
  }
}
